import messages from "../../../languages/index";
import store from "../../../store";
let language = store.state.language || "pt";

const RoutersAgent = [
  // Sector: Dashboard
  {
    name: "AgentDashboard",
    path: "AgentDash",
    redirect: {
      name: "AgentDashboardHome",
    },
    meta: {
      nameDrawer: messages[language].dashboard,
      active: true,
      icon: "mdi-view-dashboard",
      operator: true,
    },
    //Index (router-view)
    component: () => import("@/views/dashboard/agent"),
    children: [
      {
        name: "AgentDashboardHome",
        path: "home",
        meta: {
          nameDrawer: messages[language].overview,
          operator: true,
        },
        component: () => import("@/views/dashboard/agent/dashboard/home"),
      },
    ],
  },
  // Campaigns
  {
    name: "AgentCampaigns",
    path: "campaigns",
    meta: {
      nameDrawer: messages[language].affiliateCampaign.title,
      icon: "mdi-web-check",
      operator: true,
    },
    //Index (router-view)
    component: () => import("@/views/dashboard/agent"),
    // component: () => import("@/views/dashboard/agent/campaigns/campaigns.vue"),
    children: [
      {
        name: "AgentListCampaigns",
        path: "list-campaigns",
        meta: {
          nameDrawer: messages[language].affiliateCampaign.title,
          operator: true,
        },
        component: () =>
          import("@/views/dashboard/agent/campaigns/campaigns.vue"),
      },
    ],
  },

  // Sector: Bet
  // aqui
  {
    name: "AgentBet",
    path: "bet",
    meta: {
      nameDrawer: messages[language].bets,
      operator: true,
      icon: "mdi-ticket-confirmation",
    },
    //Index (router-view)
    component: () => import("@/views/dashboard/agent"),
    children: [
      {
        name: "AgentBetHistoric",
        path: "historic",
        meta: {
          nameDrawer: messages[language].historic,
          operator: true,
          request: true,
          filters: [
            "RangeGlobal",
            "AutocompleteNamePlayers",
            "SelectResultBet",
          ],
          filterLimitDays: 7,
        },
        component: () => import("@/views/dashboard/agent/bet/historic.vue"),
      },
      {
        name: "AgentBetValidate",
        path: "validate",
        meta: {
          nameDrawer: messages[language].validatePreBet,
          operator: true,
        },
        component: () => import("@/views/dashboard/agent/bet/validate.vue"),
      },
      {
        name: "AgentBetPay",
        path: "pay",
        meta: {
          nameDrawer: messages[language].payPremium,
          operator: true,
        },
        component: () => import("@/views/dashboard/agent/bet/pay.vue"),
      },
      {
        name: "AgentBetCancel",
        path: "cancel",
        meta: {
          nameDrawer: messages[language].cancelBet,
          operator: true,
        },
        component: () => import("@/views/dashboard/agent/bet/cancel.vue"),
      },
    ],
  },

  // Sector: Credit
  {
    name: "AgentCredit",
    path: "credit",
    meta: {
      nameDrawer: messages[language].credit,
      icon: "mdi-cash",
      operator: true,
    },
    //Index (router-view)
    component: () => import("@/views/dashboard/agent"),
    children: [
      {
        name: "AgentCreditHistoric",
        path: "historic",
        meta: {
          nameDrawer: messages[language].historic,
          operator: true,
          request: true,
          filters: ["RangeGlobal"],
        },
        component: () => import("@/views/dashboard/agent/credit/historic"),
      },
      {
        name: "AgentSellCredit",
        path: "sellCredit",
        meta: {
          nameDrawer: messages[language].sellCredit,
          operator: true,
        },
        component: () => import("@/views/dashboard/agent/credit/sellCredit"),
      },
    ],
  },

  // Sector: Financial (FINANCEIRO) Retail 2
  // Financeiro apenas para o Retail 2
  {
    name: "AgentFinancial",
    path: "financial",
    meta: {
      nameDrawer: messages[language].financial,
      operator: true,
      icon: "mdi-wallet-outline",
    },
    //Index (router-view)
    component: () => import("@/views/dashboard/agent"),
    children: [
      // Clientes registrados
      {
        name: "AgentCustomers",
        path: "registeredCustomers",
        meta: {
          nameDrawer: messages[language].registeredCustomers,
          operator: true,
          filters: ["RangeGlobal", "AutocompleteNamePlayers"],
        },
        component: () =>
          import("@/views/dashboard/agent/clients/registeredCustomers.vue"),
      },
      // Jogadores afiliados
      {
        name: "ListAffiliates",
        path: "listAffiliates",
        meta: {
          nameDrawer: messages[language].affiliatedPlayers,
          operator: true,
          request: true,
          filters: ["RangeGlobal", "GroupExport"],
        },
        component: () =>
          import("@/views/dashboard/agent/financial/listAffiliates"),
      },
      // Extrato
      {
        name: "AgentFinancialExtract",
        path: "extract",
        meta: {
          nameDrawer: messages[language].extract,
          operator: true,
          request: true,
          filters: ["RangeGlobal"],
        },
        component: () => import("@/views/dashboard/agent/financial/extract"),
      },
      // Comissoes
      {
        name: "AgentFinancialCommissions",
        path: "commissions",
        redirect: {
          name: "AffiliatesCommissions",
        },
        meta: {
          nameDrawer: messages[language].commissions,
          operator: true,
          request: true,
          // filters: ["RangeGlobal"],
        },
        component: () =>
          import("@/views/dashboard/agent/financial/revenueShareAndCpa/"),
        children: [
          {
            name: "AffiliatesCommissions",
            path: "revenueShare",
            meta: {
              nameDrawer: "Revenue Share",
              operator: true,
              request: true,
              filters: ["RangeGlobal", "GamingType"],
            },
            component: () =>
              import(
                "@/views/dashboard/agent/financial/revenueShareAndCpa/revenueShare/"
              ),
          },
          {
            name: "AffiliatesCpa",
            path: "cpa",
            meta: {
              nameDrawer: "CPA",
              operator: true,
              request: true,
              filters: ["RangeGlobal"],
            },
            component: () =>
              import(
                "@/views/dashboard/agent/financial/revenueShareAndCpa/cpa/"
              ),
            beforeEnter(to, from, next) {
              // affiliateCpaType == 0 Sem comissão de CPA
              let affiliateCpaType = store.state.affiliateCpaType;
              if (affiliateCpaType == "0") {
                next({ name: "AffiliatesCommissions" });
              }
              next();
            },
          },
        ],
      },
    ],
  },

  {
    name: "AffiliatesTransfers",
    path: "transfers",
    meta: {
      nameDrawer: messages[language].affiliatesPayments.transfers,
      operator: false,
      icon: "mdi-cash",
    },
    component: () => import("@/views/dashboard/agent"),
    children: [
      {
        name: "AffiliatesLinkPlayer",
        path: "linkPlayer",
        meta: {
          nameDrawer: messages[language].affiliatesPayments.linkPlayer,
          operator: true,
          request: true,
        },
        component: () => import("@/views/dashboard/agent/financial/linkPlayer"),
      },
      {
        name: "AffiliatesTransfersHistoric",
        path: "historic",
        meta: {
          nameDrawer: messages[language].historic,
          operator: true,
          request: true,
          filters: ["PaymentMonth"],
        },
        component: () => import("@/views/dashboard/agent/financial/transfers"),
      },
    ],
  },

  // Sector: Financial (BANCO) Retail Simplificado (1)
  // Financeiro apenas para o Retail Simplificado (1)
  {
    name: "AgentFinancialSimplified",
    path: "financialSimplified",
    meta: {
      nameDrawer: messages[language].bank,
      operator: true,
      icon: "mdi-wallet-outline",
    },
    //Index (router-view)
    component: () => import("@/views/dashboard/agent"),
    children: [
      {
        name: "AgentFinancialExtractSimplified",
        path: "extractSimplified",
        meta: {
          nameDrawer: messages[language].extract,
          operator: true,
          request: true,
          filters: ["RangeGlobal"],
        },
        component: () =>
          import("@/views/dashboard/agent/financial/extractSimplified"),
      },
      {
        name: "AgentFinancialCommissionsSimplified",
        path: "commissionsSimplified",
        redirect: {
          name: "AffiliatesCommissions",
        },
        meta: {
          nameDrawer: messages[language].commissions,
          operator: true,
          request: true,
          filters: ["RangeGlobal", "GamingType"],
        },
        // component: () =>
        //   import("@/views/dashboard/agent/financial/commissions"),
        component: () =>
          import("@/views/dashboard/agent/financial/revenueShareAndCpa/"),
        children: [
          {
            name: "AffiliatesRevenueshareSimplified",
            path: "revenueShare",
            meta: {
              nameDrawer: "Revenue Share",
              operator: true,
              request: true,
              filters: ["RangeGlobal", "GamingType"],
            },
            component: () =>
              import(
                "@/views/dashboard/agent/financial/revenueShareAndCpa/revenueShare/"
              ),
          },
          {
            name: "AffiliatesCpaSimplified",
            path: "cpa",
            meta: {
              nameDrawer: "CPA",
              operator: true,
              request: true,
              filters: ["RangeGlobal"],
            },
            component: () =>
              import(
                "@/views/dashboard/agent/financial/revenueShareAndCpa/cpa/"
              ),
            beforeEnter(to, from, next) {
              // affiliateCpaType == 0 Sem comissão de CPA
              let affiliateCpaType = store.state.affiliateCpaType;
              if (affiliateCpaType == "0") {
                next({ name: "AffiliatesCommissions" });
              }
              next();
            },
          },
        ],
      },
      {
        name: "ListAffiliatesSimplified",
        path: "listAffiliatesSimplified",
        meta: {
          nameDrawer: messages[language].affiliatedPlayers,
          operator: true,
          request: true,
          filters: ["RangeGlobal", "GroupExport"],
        },
        component: () =>
          import("@/views/dashboard/agent/financial/listAffiliates"),
      },
    ],
  },

  // Relatórios
  {
    name: "AgentReports",
    path: "reports",
    meta: {
      nameDrawer: messages[language].reports,
      operator: true,
      icon: "mdi-chart-bar",
    },
    //Index (router-view)
    component: () => import("@/views/dashboard/agent"),
    children: [
      {
        name: "AgentUsersReport",
        path: "users",
        meta: {
          nameDrawer: messages[language].users,
          operator: true,
          request: true,
          filters: ["RangeGlobal", "GroupExport"],
          filterLimitDays: 31,
        },
        component: () => import("@/views/dashboard/agent/reports/users"),
        beforeEnter(to, from, next) {
          let isAffiliate = store.state.logged.is_afilliate;
          if (isAffiliate != "0") {
            next();
          } else {
            next("/");
          }
        },
      },
      {
        name: "AgentSportsReport",
        path: "sports",
        meta: {
          nameDrawer: messages[language].bets,
          operator: true,
          request: true,
          filters: ["RangeGlobal", "GroupExport"],
          filterLimitDays: 15,
        },
        component: () =>
          import("@/views/dashboard/agent/reports/sportsbookBet"),
        beforeEnter(to, from, next) {
          let isAffiliate = store.state.logged.is_afilliate;
          if (isAffiliate != "0") {
            next();
          } else {
            next("/");
          }
        },
      },
      // {
      //   name: "AgentDepositsReport",
      //   path: "deposits",
      //   meta: {
      //     nameDrawer: messages[language].deposits,
      //     operator: true,
      //     request: true,
      //     filters: ["RangeGlobal", "GroupExport"],
      //     filterLimitDays: 31,
      //   },
      //   component: () =>
      //     import("@/views/dashboard/agent/reports/deposits"),
      //     beforeEnter(to, from, next) {
      //       let isAffiliate = store.state.logged.is_afilliate;
      //       if (isAffiliate != "0") {
      //         next();
      //       } else {
      //         next("/");
      //       }
      //     },
      // },
    ],
  },

  // Sector: Account
  {
    name: "AgentAccount",
    path: "account",
    meta: {
      nameDrawer: messages[language].account,
      operator: true,
      icon: "mdi-account-circle",
    },
    //Index (router-view)
    component: () => import("@/views/dashboard/agent"),
    children: [
      {
        name: "AgentAccountChangePassword",
        path: "changePassword",
        meta: {
          nameDrawer: messages[language].changePassword,
          operator: true,
        },
        component: () =>
          import("@/views/dashboard/agent/account/changePassword"),
      },
    ],
  },
];
export default RoutersAgent;
